import type { ReactNode } from 'react';
import { Circle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui';
import { EmbedHostProvider } from '@/contexts/EmbedHostContext';
import { useOrgPublicProfile } from '@/contexts/OrgPublicProfileContext';
import { PublicOrgLayout } from '@/components/layout/PublicOrgLayout';

function PublicOrgRouteShellContent({ children }: { children: ReactNode }) {
  const { profile, isLoading, error } = useOrgPublicProfile();

  if (isLoading) {
    return (
      <main className="flex min-h-screen items-center justify-center p-6">
        <Loader2 className="h-8 w-8 animate-spin text-foreground" aria-label="Loading" />
      </main>
    );
  }

  if (error || !profile) {
    return (
      <main className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
        <Circle className="mb-4 h-12 w-12 text-muted-foreground" aria-hidden />
        <h1 className="text-xl font-semibold text-foreground">Organization not found</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {error || 'This page is unavailable.'}
        </p>
        <Button className="mt-4" onClick={() => window.location.assign('/')}>
          Go home
        </Button>
      </main>
    );
  }

  return <PublicOrgLayout profile={profile}>{children}</PublicOrgLayout>;
}

export function PublicOrgRouteShell({ children }: { children: ReactNode }) {
  return (
    <EmbedHostProvider>
      <PublicOrgRouteShellContent>{children}</PublicOrgRouteShellContent>
    </EmbedHostProvider>
  );
}
